import { render, staticRenderFns } from "./ListAis.vue?vue&type=template&id=5c13c0dc&"
import script from "./ListAis.vue?vue&type=script&lang=js&"
export * from "./ListAis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports